var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-button',{attrs:{"type":"primary","size":"mini","plain":"","loading":_vm.loading,"title":"Migrate"},on:{"click":_vm.onSubmit}},[_vm._v(" Migrate ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }